import {post} from 'common/utils/http';

const root = 'api/v1/auditlog';

// eslint-disable-next-line import/prefer-default-export
export const fetchAuditLog = ({payload}) => post(`${root}/search?customerId=${payload.customerId}`, payload);
